/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/lightbulb'
export default icon
